import React, { Component } from "react";
import { connect } from 'react-redux';
import * as url from './../../../utils/url';
import axios from './../../../axios';
import * as actionCreators from '../../../modules/actions/index';
import MapSeparation from './../../../components/OrganizationSetup/MapSeparation/MapSeparation';
import EnterpriseBreadcrumb from './../../../components/EnterpriseBreadcrumb/EnterpriseBreadcrumb';

class MapSeparationManagement extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    const {organizationId} = this.props.user;
    axios.get(url.getExistingMappings(organizationId._id)).then(({data}) => {
      const payload = data.data;
      const {separation} = payload.mapping;
      if(separation.columnName) {
        this.props.onMatchColumn(separation.columnName);
      }
      const separationData = separation.data;
      let allMapping = []
      separationData.forEach((c) => {
        const mapping = c.values.map((v) => {
          return {
            value : v,
            column : {
              label : c.reference.name,
              value : c.reference._id
            }
          }
        })
        allMapping = allMapping.concat(mapping);
      })
      this.props.saveAllSeparationMapping(allMapping);
    })
  }

  componentWillUnmount() {
    this.props.resetMapSeparationStep();
  }
  handleFileUpload = (columns, data, file) => {
    this.props.onFileDataProcessed(columns, data, file);
  }

  handleMatchColumn = (matchedColumn) => {
    this.props.onMatchColumn(matchedColumn);
  }

  handleSkipMapping = () => {
    // console.log('Skip separa .tion mapping');
  }

  render() {
    return (
      <div className="mt60 enterprise-map-page">
      <EnterpriseBreadcrumb 
        linkText="Enterprise Management" 
        link="/home/enterprise-info" 
        activeText="Map Separation"
        {...this.props}
        />
      <MapSeparation 
        onProcessedFileUploadData={this.handleFileUpload}
        onMapGenderMatchColumn={this.handleMatchColumn}
        onSkipSeparationMapping={this.handleSkipMapping}
        isRepeatFlow={true}
        {...this.props}/>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    user: state.user.profile,
    mapSeparation : state.mapping.separation
  }
}

const mapDispatchToProps = dispatch => {
	return {
    resetMapSeparationStep: () => dispatch(actionCreators.resetMapSeparationStep()),
    nextStep: () => dispatch(actionCreators.mapSeparationNextStep()),
    goBack : () => dispatch(actionCreators.mapSeparationGoBack()),
    reset : () => dispatch(actionCreators.resetSeparations()),
    saveAllSeparationMapping : (o,s) => dispatch(actionCreators.saveAllSeparationMapping(o,s)),
    onFileDataProcessed: (c,d,f) => dispatch(actionCreators.mapSeparationUploadFileSuccess(c,d,f)),
    onMatchColumn: data => dispatch(actionCreators.mapSeparationMatchColumnSuccess(data))
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(MapSeparationManagement);